import React from 'react';
import "../../../../styles/vzyfaq.css";
import { UseHookfaq } from './hook';
import FaqAccordionItem from './faqAccordionItem';
import VideoContainer from './videocontainer';

const Faq = ()=> {
	const {
		activeTab,
		handleTabClick,
		entryList,
		entryVideoList
	} = UseHookfaq();

	return (
		<div id="containerVZY" className='vzyfaq'>
			<div id="faqline">
			<div id="faq-page">
				<div className="app-middle">
					<div className="faq-section">
						<div className="faq-header">
							<div className="content-header">
								<div className="header-name">
									<h2>Frequently Asked Questions</h2>
								</div>
							</div>
						</div>
						<ul className="nav nav-tabs" id="myWatcho" role="tablist">
							<li className="nav-item">
								<button
									className={`nav-link ${activeTab === "ACCOUNT_RELATED" ? "active" : ""}`}
									onClick={() => handleTabClick("ACCOUNT_RELATED")}
								>
									Account Related
								</button>
							</li>
							<li className="nav-item">
								<button
									className={`nav-link ${activeTab === "WATCHO_ONE" ? "active" : ""}`}
									onClick={() => handleTabClick("WATCHO_ONE")}
								>
									OTT Plans and Bundle
								</button>
							</li>
							<li className="nav-item">
								<button
									className={`nav-link ${activeTab === "WATCHO_EXCLUSIVE" ? "active" : ""}`}
									onClick={() => handleTabClick("WATCHO_EXCLUSIVE")}
								>
									Offers Details
								</button>
							</li>
							<li className="nav-item">
								<button
									className={`nav-link ${activeTab === "SUBSCRIPTIONS" ? "active" : ""}`}
									onClick={() => handleTabClick("SUBSCRIPTIONS")}
								>
									Subscribe, Cancel & Renew
								</button>
							</li>
						</ul>
						<div className="tab-content" id="MyWatchoContent">
							<div
								className={`tab-pane fade vzytab ${activeTab === "ACCOUNT_RELATED" ? "show active" : ""}`}
								id="watcho"
							>
								<div className="faq-content">
									{entryList && (
										entryList?.responseList?.map((ele) => (
											<FaqAccordionItem question={ele.question} id={''} answerList={ele.answerList[0]} videoUrl={ele.videoUrl} type={ele.type} position={ele.position} status={ele.status} category={ele.category} />
										))
									)}
								</div>
								{entryVideoList?.responseList !== null &&
									<div className="video-container VZY-Video">
										<h2>Self-help Videos</h2>
										<ul>
											{
												entryVideoList?.responseList?.map((ele) => (
													<VideoContainer question={ele.question} id={''} videoUrl={ele.videoUrl} type={ele.type} position={ele.position} status={ele.status} category={ele.category} answerList={ele.answerList} />
												))
											}
										</ul>
									</div>
								}
							</div>
							<div
								className={`tab-pane fade vzytab ${activeTab === "WATCHO_ONE" ? "show active" : ""}`}
								id="watchoone"
							>
								<div className="faq-content">
									{entryList && (
										entryList?.responseList?.map((ele) => (
											<FaqAccordionItem question={ele.question} id={''} answerList={ele.answerList[0]} videoUrl={ele.videoUrl} type={ele.type} position={ele.position} status={ele.status} category={ele.category} />
										))
									)}
								</div>
								{entryVideoList?.responseList !== null &&
									<div className="video-container VZY-Video">
										<h2>Self-help Videos</h2>
										<ul>
											{
												entryVideoList?.responseList?.map((ele) => (
													<VideoContainer question={ele.question} id={''} videoUrl={ele.videoUrl} type={ele.type} position={ele.position} status={ele.status} category={ele.category} answerList={ele.answerList} />
												))
											}
										</ul>
									</div>
								}
							</div>
							<div
								className={`tab-pane fade vzytab ${activeTab === "WATCHO_EXCLUSIVE" ? "show active" : ""}`}
								id="watchoott"
							>
								<div className="faq-content">
									{entryList && (
										entryList?.responseList?.map((ele) => (
											<FaqAccordionItem question={ele.question} id={''} answerList={ele.answerList[0]} videoUrl={ele.videoUrl} type={ele.type} position={ele.position} status={ele.status} category={ele.category} />
										))
									)}
								</div>
								{entryVideoList?.responseList !== null &&
									<div className="video-container VZY-Video">
										<h2>Self-help Videos</h2>
										<ul>
											{
												entryVideoList?.responseList?.map((ele) => (
													<VideoContainer question={ele.question} id={''} videoUrl={ele.videoUrl} type={ele.type} position={ele.position} status={ele.status} category={ele.category} answerList={ele.answerList} />
												))
											}
										</ul>
									</div>
								}
							</div>
							<div
								className={`tab-pane fade vzytab ${activeTab === "SUBSCRIPTIONS" ? "show active" : ""}`}
								id="watchosub"
							>
								<div className="faq-content">
									{entryList && (
										entryList?.responseList?.map((ele) => (
											<FaqAccordionItem question={ele.question} id={''} answerList={ele.answerList[0]} videoUrl={ele.videoUrl} type={ele.type} position={ele.position} status={ele.status} category={ele.category} />
										))
									)}
								</div>
								{entryVideoList?.responseList !== null &&
									<div className="video-container VZY-Video">
										<h2>Self-help Videos</h2>
										<ul>
											{
												entryVideoList?.responseList?.map((ele) => (
													<VideoContainer question={ele.question} id={''} videoUrl={ele.videoUrl} type={ele.type} position={ele.position} status={ele.status} category={ele.category} answerList={ele.answerList} />
												))
											}
										</ul>
									</div>
								}
							</div>
						</div>
					</div>
				</div>
			</div>
			</div>
		</div>
	);
}
export default Faq;
